import { css } from '@bts-web/utils-style-engine';
import {
  ListCellsSelectionItem as DesignListCellsSelectionItem,
  ListCellsSelectionItemProps,
} from '@bts-web/design-system/component/list-cells-selection';
import {
  ListCellsSelectionIndicator,
  ListCellsSelectionItemContainer,
  ListCellsSelectionCheckboxIndicator,
} from './index';

type ThemedListCellsSelectionItemProps = Omit<
  ListCellsSelectionItemProps,
  'value'
> & {
  visual: 'radio' | 'checkbox';
  activeItemId?: string;
  value?: string;
  label: string;
  subLabel?: string;
  separator?: string;
  isDisabled?: boolean;
  checked?: boolean;
  onCheckedChange?: () => void;
};

const displayFlexWithCenteredItems = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const ThemedListCellsSelectionItem = ({
  activeItemId = '',
  id,
  label,
  subLabel,
  value = '',
  visual,
  isDisabled = false,
  checked = false,
  onCheckedChange,
  ...rest
}: ThemedListCellsSelectionItemProps) => {
  if (visual === 'checkbox') {
    const idString = `checkbox-id-${id}`;

    return (
      <ListCellsSelectionItemContainer
        isActive={checked}
        label={label}
        subLabel={subLabel}
        itemId={idString}
        isDisabled={isDisabled}
        icon={
          <>
            <input
              type="checkbox"
              className={css({ display: 'none' })}
              id={idString}
              checked={checked}
              disabled={isDisabled}
              onChange={onCheckedChange}
              aria-label={`checkbox answer ${label}`}
            />

            <ListCellsSelectionCheckboxIndicator
              checked={checked}
              isDisabled={isDisabled}
            />
          </>
        }
      />
    );
  }

  return (
    <ListCellsSelectionItemContainer
      activeItemId={activeItemId}
      label={label}
      subLabel={subLabel}
      itemId={id}
      isDisabled={isDisabled}
      icon={
        <DesignListCellsSelectionItem
          {...rest}
          className={css({
            ...displayFlexWithCenteredItems,
            flexShrink: 0,
            width: '20px',
            height: '20px',
            borderRadius: '50%',
            border: '1.5px solid',
            borderColor: 'neutrals.text_secondary',
            '&[data-state="checked"]': {
              borderColor: 'positive.fill_primary',
              backgroundColor: 'positive.fill_primary',
            },
            '&:disabled, &[data-disabled]': {
              borderColor: 'neutrals.text_disabled',
            },
          })}
          disabled={isDisabled}
          id={id}
          value={value}
        >
          <ListCellsSelectionIndicator visual="radio" />
        </DesignListCellsSelectionItem>
      }
    />
  );
};

export { ThemedListCellsSelectionItem as ListCellsSelectionItem };
